import { Link } from "react-router-dom";
import { dailyBrief } from "@/mocks/articles";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20moody%20editorial%20background%20with%20warm%20amber%20and%20deep%20terracotta%20light%20streaks%2C%20soft%20film%20grain%20texture%2C%20dark%20cinematic%20atmosphere%2C%20no%20people%2C%20artistic%20abstract%20composition&width=1600&height=900&seq=hl-hero-bg-01&orientation=landscape"
        alt="黑料今日日报背景图"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-45"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/85 to-foreground-950/45" />

      <div className="relative px-4 md:px-8 py-14 md:py-24">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7 w-full hl-rise">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
              <i className="ri-flashlight-fill" />
              {dailyBrief.issue} · {dailyBrief.date}
            </span>
            <h1 className="mt-5 font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 leading-[1.12]">
              每日爆料精选
              <br />
              一站看全
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-200 max-w-xl leading-relaxed">
              {dailyBrief.lead}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/daily"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-newspaper-line" />
                阅读今日日报
              </Link>
              <Link
                to="/daily"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/30 text-background-100 font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-layout-grid-line" />
                按栏目追更
              </Link>
            </div>
            <dl className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
              {[
                { k: "286", v: "期已更新" },
                { k: "8", v: "个内容栏目" },
                { k: "09:00", v: "每日更新" },
              ].map((s) => (
                <div key={s.v} className="border-l-2 border-primary-500 pl-3">
                  <dt className="font-heading font-bold text-2xl text-background-50">{s.k}</dt>
                  <dd className="text-xs text-background-300 mt-1">{s.v}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5 w-full hl-rise">
            <div className="rounded-lg bg-background-50 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h2 className="font-heading font-bold text-lg text-foreground-950">今日速览</h2>
                <span className="text-xs text-foreground-500">
                  <i className="ri-live-line text-primary-500 mr-1" />
                  实时更新
                </span>
              </div>
              <ul className="mt-4 space-y-3">
                {dailyBrief.highlights.map((h, i) => (
                  <li key={h} className="flex gap-3">
                    <span className="shrink-0 w-6 h-6 rounded-md bg-accent-100 text-accent-900 text-xs font-bold flex items-center justify-center">
                      {i + 1}
                    </span>
                    <p className="text-sm text-foreground-700 leading-relaxed">{h}</p>
                  </li>
                ))}
              </ul>
              <Link
                to="/daily"
                className="mt-5 flex items-center justify-center gap-2 w-full px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看完整日报
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}